import { useBellaSelector } from 'Client/redux/hooks';

const useLoginState = () => {
    const appShellLogin = useBellaSelector(state => state.appShellLogin);

    const loginState = { ...appShellLogin };

    return loginState;
};

export default useLoginState;
